import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Input, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";

interface ISalesArgumentForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
}

export const SalesArgumentForm: React.FC<ISalesArgumentForm> = ({ loading, form, submit }) => {
  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Input
          label="Thème"
          className="w-full"
          {...form.register("theme", { required: "Thème requis" })}
          placeholder="Qu'est-ce que HTTPS et pourquoi c'est important"
        />
        <Textarea
          label="Argumentaire"
          className="w-full"
          {...form.register("content", { required: "Contenu requis" })}
          placeholder="Contenu de l'argumentaire à tenir face au client..."
        />
      </div>

      <div className="w-full mt-4">
        <Button onClick={submit} loading={loading} disabled={loading}>
          Valider
        </Button>
      </div>
    </div>
  );
};
